import Relay from 'react-relay';
/**
*  New locker mutation
*/
export default class NewLockerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      newLocker
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      locker: {
        ...this.props.locker
      }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on newLockerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
        locker {
            id, 
            name,
            description, 
            status,
            accessMinutes {
                before,
                after
            }
            infrastructures {
                id
            }
            externalId,
            accessControl {
              enableNoAccessControl,
              automaticNoAccessControl {
                  monday {
                      from, 
                      to
                  },
                  tuesday {
                      from, 
                      to
                  },
                  wednesday {
                      from, 
                      to
                  },
                  thursday {
                      from, 
                      to
                  },
                  friday {
                      from, 
                      to
                  },
                  saturday {
                      from, 
                      to
                  },
                  sunday {
                      from, 
                      to
                  }
              }
            }
        }
      }
    `;
  }

  /**
  *  Config
  */
 getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/NewLockerMutation.js